import {
  cl,
  flashSaleCountdown,
  makeScrollbar,
  sluggify,
  sortArray,
  toggleMapList,
  trimToLowerCase,
  undefinedVariables
} from "./common/functions";
import { $, variables } from "./common/variables";
import { ajax } from "./components/ajax";
import { createFilters } from "./components/filters";
import { geolocation } from "./components/geolocation";
import { map, markersCluster } from "./components/leaflet/leaflet__map-init";
import { loader } from "./components/loader";
import {
  markerClusterSpiderify,
  markerEvent,
  markeractiveState,
  zoomend
} from "./components/map-events";
import { resetLocation } from "./components/resetLocation";
import { search } from "./components/search";

if (document.getElementById("map") !== null) {
  if (variables !== undefined) {
    /*------------Variables------------*/
    //Layer de markers
    let markersLayer = new L.LayerGroup();
    // recuperation des valeurs du shortcode
    if (variables.shortcodeTypeValue !== null) {
      /*------------ [AJAX] success------------*/
      const success = data => {

        const offset = map.getSize().x * 0.2;

        loader();

        //sort random
        sortArray(data);

        //clear des markers
        markersLayer.clearLayers();

        //initialisation de l'array qui vas servir au filtres
        const mapArray = [];
        const mapArrayType = [];
        const mapArraySubType = [];
        const mapArrayTypeTitle = ["Thématique", "Type"];

        for (let i = 0; i < data.length; i++) {
          //json datas
          let id = data[i].id;
          let name = data[i].name;
          let second_name = data[i].second_name;
          let address = data[i].address;
          let type =
            data[i].type
              .replaceAll(" / ", "-")
              .replaceAll(" ", "-")
              .replaceAll("é", "e")
              .replaceAll("è", "e")
              .replaceAll("ê", "e")
              .toLowerCase() || null;
          let type_icon = data[i].type_icon;
          const type_id = data[i].type_id;
          let schedule = data[i].schedule;
          schedule = undefinedVariables(schedule);
          let todaySchedule = data[i].todaySchedule;
          todaySchedule = undefinedVariables(todaySchedule);
          let promo = data[i].promo;
          promo = undefinedVariables(promo);
          let regles = data[i].regles;
          regles = undefinedVariables(regles);
          let regle_max = data[i].regle_max;
          regle_max = undefinedVariables(regle_max);
          let image = data[i].image;
          image = undefinedVariables(image);

          if (type && type_id) {
            // Remplissage de array de toutes les sous-types
            // Remplissage de l'array des filtres pour le marker
            const subTypes = data[i].sub_types
            const markerTypeArray = []
            if (subTypes.length) {
              subTypes.forEach(subType => {
                if (!mapArraySubType.some(subTypeElement => subTypeElement.id === subType.id)) {
                  mapArraySubType.push(subType);
                }
                if (subType.label.length) {
                  const slugLabel = sluggify(subType.label)
                  if (!markerTypeArray.some(subTypeElement => subTypeElement === slugLabel)) {
                    markerTypeArray.push(slugLabel);
                  }
                }
              })
            }

            // Remplissage de l'array des types
            const typeObject = { id: type_id, name: type, icon: type_icon };
            if (!mapArrayType.some(typeElement => typeElement.name === type)) {
              mapArrayType.push(typeObject)
            }

            type = trimToLowerCase(type)

            markerTypeArray.push(type)

            variables.shortcodeTypeValue = trimToLowerCase(
              variables.shortcodeTypeValue
            );

            if (
              variables.shortcodeTypeValue.includes(type) ||
              variables.shortcodeTypeValue.includes("all")
            ) {


              // [MARKER]Creation des markers
              //Custom marker icon
              let customMarker = L.divIcon({
                iconSize: [40, 40],
                iconAnchor: [20, 40],
                className: `${type}`,
                html: /* html */ `
                  <div id="leaflet-marker-icon__${i + 1}">
                    <svg class="marker-cluster">
                      <use xlink:href="${variables.parentThemePath}/assets/img/markers/marker-${type}.svg#Calque_1" tabindex="0"></use></svg>
                    <div class="pulse"></div>
                  </div>
                `,
                popupAnchor: [0, -40]
              });

              let scheduleTag = "";
              if (schedule.length !== 0) {
                scheduleTag = /* html */ `<p class="gl-popup__schedule">${schedule}</p>`;
              }

              const markerName = `${name}${second_name}`

              for (let j = 0; j < address.length; j++) {
                if (address[j].latitude && address[j].longitude) {
                  //creation du marker
                  const marker = L.marker([address[j].latitude, address[j].longitude], {
                    tags: markerTypeArray, //pour les filtres
                    name: markerName.normalize("NFD").replace(/[\u0300-\u036f]/g, ""), // pour la recherche
                    icon: customMarker,
                    markerId: `${i}`,
                    shopId: id
                  });
                  if (variables.shortcodeTemplateValue === "onlymap") {
                    marker.bindPopup(/* html */
                      `<div class="gl-popup ${type}">
                          <h2 class="gl-popup__title">${name}</h2>
                          ${scheduleTag}
                        </div>`
                    );
                  }

                  // [MARKER] Affiche les markers sur la map avec Fitbound (sans clustering)
                  variables.markers.push(marker);
                  markersCluster.addLayer(marker);
                }
              }

              if (variables.shortcodeTemplateValue === "full") {
                // [DOM] Creation de la liste des magasins
                let mapList = document.getElementById("stores__container");

                let contentStoreImage = /* html */ `<div class="item__image">${type_icon}</div>`;
                if (image.length > 0) {
                  contentStoreImage = `<div class="item__image"><img src="${image}" alt=""></div>`;
                }

                let contentStoreRegle = "";
                if (regle_max > 0) {
                  contentStoreRegle = /* html */ `<div class="item__points">Jusqu'à -${regle_max}%</div>`;
                }

                if (todaySchedule.length > 0) {
                  todaySchedule = " - " + todaySchedule;
                }

                if (second_name) {
                  second_name = /* html */ `<h4 class="text__subtitle">${second_name}</h4>`;
                }

                let contentStoreContainer = /* html */ `
                  <a
                    href="?id=${id}"
                    id="item-${i}"
                    class="container__item ${markerTypeArray.length ? markerTypeArray.join(' ') : ''}"
                    data-display="true"
                    data-marker="${i}"
                    data-shop="${id}"
                  >
                    ${contentStoreImage}
                    <div class="item__text">
                      <div class="text__wrapper">
                        <h3 class="text__title">${name}</h3>
                        ${second_name}
                      </div>
                      ${contentStoreRegle}
                      <div class="text__schedule"><strong>${schedule}</strong>${todaySchedule}</div>
                    </div>
                  </a>
                `;
                mapList.insertAdjacentHTML(
                  "beforeend",
                  contentStoreContainer
                );

                let mapElement = document.getElementById(`item-${i}`);

                // [MARKER] Select marker via list
                const listSelect = event => {
                  if (window.innerWidth <= variables.breakpoint) {
                    toggleMapList(
                      variables.mapTab,
                      variables.storeTab,
                      variables.mapContainer,
                      variables.storeContainer
                    );
                  }
                  if (!mapElement.classList.contains("selected")) {
                    setTimeout(() => {
                      let items = document.getElementsByClassName("container__item");
                      //add class selected
                      for (let i = 0; i < items.length; i++) {
                        items[i].classList.remove("selected");
                      }
                      setTimeout(() => {
                        mapElement.scrollIntoView({
                          behavior: "smooth",
                          block: "center",
                          inline: "start"
                        });
                      }, 0);

                      // ajoute une classe active sur les cluster/marker
                      const marker = markeractiveState(
                        mapElement,
                        variables.markers,
                        markersCluster
                      );

                      if (marker) {
                        //zoom quand on selectionne dans la liste
                        const markerPositionBis = map.latLngToContainerPoint(
                          marker.getLatLng()
                        );
                        const newPositionBis = L.point([
                          markerPositionBis.x - offset,
                          markerPositionBis.y
                        ]);
                        const newLatLngBis = map.containerPointToLatLng(
                          newPositionBis
                        );
                        map.setView(newLatLngBis, map.getZoom(), {
                          animate: true
                        });
                        mapElement.classList.add("selected");
                      }
                    }, 0);
                  }
                };
                mapElement.addEventListener("click", listSelect, false);

                function showShopPanel(event) {
                  event.preventDefault();
                  if (!mapElement.classList.contains("selected")) {
                    let fancyboxLink = $(this).attr("href");

                    $.fancybox.destroy();
                    $.fancybox.open({
                      src: fancyboxLink + "&format=popup",
                      type: "ajax",
                      parentEl: "#storeSingle",
                      touch: false,
                      hideScrollbar: true,
                      afterLoad: function (instance, current) {
                        if ($(window).width() > 768) {
                          setTimeout(() => {
                            $("#overlayScrollbar").overlayScrollbars({
                              scrollbars: {
                                autoHide: "leave",
                                autoHideDelay: 400
                              }
                            });
                          }, 100);
                        }
                        $(".venteFlash__counter-countdown .countdown").each(
                          function () {
                            variables.flashSaleCountdown(this);
                          }
                        );
                      },
                      beforeClose: function () {
                        let items = document.getElementsByClassName(
                          "container__item"
                        );
                        for (let i = 0; i < items.length; i++) {
                          items[i].classList.remove("selected");
                        }
                        let markers = document.getElementsByClassName(
                          "leaflet-marker-icon"
                        );
                        for (let j = 0; j < markers.length; j++) {
                          markers[j].classList.remove("selected");
                        }
                      }
                    });
                  }
                }
                mapElement.addEventListener("click", showShopPanel, false);
              }
            }
          }
        }


        /*------------ [MAP] events ------------*/
        zoomend(map, variables.markers, markersCluster)
        markerClusterSpiderify(variables.markers, markersCluster)
        markerEvent(map, variables.markers, markersCluster, offset)

        if (type !== null) {
          if (variables.shortcodeTemplateValue === "full") {
            /*------------ [FILTERS] Create ------------*/
            createFilters(mapArray, mapArrayType, mapArrayTypeTitle, mapArraySubType, markersCluster);

            /*------------ [OVERLAYSCROLLBAR] ------------*/
            // prettier-ignore
            makeScrollbar(document.getElementById("stores__container"), "os-theme-dark", true);

            /*------------ [SEARCH] append & events  ------------*/
            search(variables.markers, markersCluster);
          }
        }

        if (variables.shortcodeGeolocalisationValue === "true") {
          geolocation(map, markersCluster);
        }

        resetLocation(map, markersCluster);

        map.addLayer(markersCluster);
        map.fitBounds(markersCluster.getBounds().pad(0));
      };

      /*------------ [AJAX] error------------*/
      const error = err => {
        cl(err);
      };

      /*------------ [AJAX] main function------------*/
      ajax(success, error);

      /*------------Template onlyMap Exception------------*/
      if (
        variables.shortcodeTemplateValue !== "full" ||
        variables.shortcodeTemplateValue === "onlymap"
      ) {
        const removeElement = id => {
          const element = document.getElementById(id);
          if (element !== null) {
            element.remove();
          }
        };
        removeElement("map__stores");
        removeElement("searchTab");
        const mapContainer = document.getElementById("map-content");
        if (mapContainer !== null) {
          mapContainer.classList.remove("col-md-7");
          mapContainer.classList.remove("col-lg-8");
          mapContainer.classList.remove("col-xl-9");
        }
      }
    }
  }
}
